module.exports = __webpack_public_path__ + "static/img/WechatIMG159.cbcfc38.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG159.jpeg
// module id = +uaj
// module chunks = 1